module.exports = __webpack_public_path__ + "img/twitter-icon.fc35e951.svg";